import { render, staticRenderFns } from "./FundingAssessmentsIndex.vue?vue&type=template&id=0a9c4ac3&"
import script from "./FundingAssessmentsIndex.vue?vue&type=script&lang=js&"
export * from "./FundingAssessmentsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports